"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _EventHandlers = require("../core/EventHandlers");

var _UILayer = _interopRequireDefault(require("../layer/UILayer"));

var _Functions = require("../core/Functions");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _decorators = require("../utils/propTypes/decorators");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var PanelContext = _interopRequireWildcard(require("../context/PanelContext"));

var _PanelNavigatorContext = require("../context/PanelNavigatorContext");

var _PanelTransition = _interopRequireDefault(require("./internal/PanelTransition"));

var _Styles = require("../utils/Styles");

var _ShareScrollElement = _interopRequireDefault(require("../decorators/ShareScrollElement"));

var _PanelComponentRegistrationContext = require("../context/PanelComponentRegistrationContext");

var inPanelContext = {
  inPanel: true
};

var getStyle = function getStyle(style, computedWidth, computedMargin) {
  return (0, _extends2.default)({}, style, {
    width: computedWidth,
    marginLeft: computedMargin,
    marginRight: computedMargin
  });
};

var getTransitionProps = function getTransitionProps(onOpenStart, onOpenComplete, onCloseStart, onCloseComplete, align, animate) {
  return {
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    onCloseStart: onCloseStart,
    onCloseComplete: onCloseComplete,
    align: align,
    duration: animate ? undefined : 0
  };
};

var getClassName = function getClassName(align, className, sandboxed) {
  return (0, _classNames.default)(className, 'private-panel', {
    'private-panel--left': align === 'left',
    'private-panel--right': align === 'right',
    'private-panel--sandboxed': sandboxed
  });
};

var getPanelClassName = function getPanelClassName(panelClassName, bodyCount, headerCount) {
  return (0, _classNames.default)(panelClassName, 'private-panel__container', {
    'private-panel__container--with-body': bodyCount > 0,
    'private-panel__container--with-header': headerCount > 0
  });
};

var UIPanel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIPanel, _React$Component);

  function UIPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIPanel).call(this, props));
    _this.state = {
      bodyCount: 0,
      headerCount: 0
    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this._getTransitionProps = (0, _memoizeOne.default)(getTransitionProps);
    _this.handleWheel = _this.handleWheel.bind((0, _assertThisInitialized2.default)(_this));
    _this._isMounted = true; // Not technically, but child context funcs are called before didMount.

    _this._hasHeader = false;
    _this._hasBody = false; // Track the number of UIPanelHeader and UIPanelBody instances this panel contains. This code
    // should be removed once all headerless/bodyless panels are eliminated.

    _this._panelComponentRegistrationContextValue = {
      registerPanelBody: function registerPanelBody() {
        _this._hasBody = true;

        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              bodyCount: state.bodyCount + 1
            };
          });
        }
      },
      unregisterPanelBody: function unregisterPanelBody() {
        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              bodyCount: state.bodyCount - 1
            };
          });
        }
      },
      registerPanelHeader: function registerPanelHeader() {
        _this._hasHeader = true;

        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              headerCount: state.headerCount + 1
            };
          });
        }
      },
      unregisterPanelHeader: function unregisterPanelHeader() {
        if (_this._isMounted) {
          _this.setState(function (state) {
            return {
              headerCount: state.headerCount - 1
            };
          });
        }
      }
    };
    return _this;
  }

  (0, _createClass2.default)(UIPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          width = _this$props.width,
          _this$props$panelNavi = _this$props.panelNavigatorContext,
          panelNavigatorContext = _this$props$panelNavi === void 0 ? {} : _this$props$panelNavi,
          scrollElementRef = _this$props.scrollElementRef;
      (0, _Functions.callIfPossible)(panelNavigatorContext.registerWidth, width); // Using the React `onWheel` event would be restrictive in Chrome (#6272)

      scrollElementRef.current.addEventListener('wheel', this.handleWheel);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(evt) {
      // Allow a custom wheel handler to override this one
      var _this$props2 = this.props,
          onWheel = _this$props2.onWheel,
          scrollElementRef = _this$props2.scrollElementRef;

      if (typeof onWheel === 'function') {
        onWheel(evt);
        return;
      }

      (0, _EventHandlers.constrainVerticalWheelEvent)(evt, scrollElementRef.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          align = _this$props3.align,
          animate = _this$props3.animate,
          children = _this$props3.children,
          className = _this$props3.className,
          onOpenStart = _this$props3.onOpenStart,
          onOpenComplete = _this$props3.onOpenComplete,
          onCloseStart = _this$props3.onCloseStart,
          onCloseComplete = _this$props3.onCloseComplete,
          __onWheel = _this$props3.onWheel,
          panelClassName = _this$props3.panelClassName,
          __panelKey = _this$props3.panelKey,
          rootNode = _this$props3.rootNode,
          scrollElementRef = _this$props3.scrollElementRef,
          style = _this$props3.style,
          width = _this$props3.width,
          _dontMakeNewLayer = _this$props3._dontMakeNewLayer,
          __panelNavigatorContext = _this$props3.panelNavigatorContext,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["align", "animate", "children", "className", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "onWheel", "panelClassName", "panelKey", "rootNode", "scrollElementRef", "style", "width", "_dontMakeNewLayer", "panelNavigatorContext"]);
      var _this$state = this.state,
          bodyCount = _this$state.bodyCount,
          headerCount = _this$state.headerCount;
      var sandboxed = this.context.sandboxed;
      var computedWidth = (style || {}).width || width;

      if (!sandboxed) {
        computedWidth = (0, _Styles.percentToVW)(computedWidth);
      }

      var computedMargin = typeof computedWidth === 'string' ? "-" + computedWidth : -computedWidth;

      var renderedPanel = _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        className: getClassName(align, className, sandboxed),
        ref: (0, _Functions.wrapRefObject)(scrollElementRef),
        style: this._getStyle(style, computedWidth, computedMargin)
      }), _react.default.createElement(_PanelComponentRegistrationContext.Provider, {
        value: this._panelComponentRegistrationContextValue
      }, _react.default.createElement("div", {
        className: getPanelClassName(panelClassName, bodyCount, headerCount)
      }, children)));

      if (_dontMakeNewLayer || sandboxed) {
        return renderedPanel;
      }

      return _react.default.createElement(_UILayer.default, {
        "data-layer-for": "UIPanel",
        rootNode: rootNode,
        Transition: _PanelTransition.default,
        transitionProps: this._getTransitionProps(onOpenStart, onOpenComplete, onCloseStart, onCloseComplete, align, animate)
      }, _react.default.createElement(PanelContext.Provider, {
        value: inPanelContext
      }, renderedPanel));
    }
  }]);
  return UIPanel;
}(_react.default.Component);

UIPanel.propTypes = {
  animate: _react.PropTypes.bool.isRequired,
  align: _react.PropTypes.oneOf(['left', 'right']).isRequired,
  children: _react.PropTypes.node,
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  panelClassName: _react.PropTypes.string,
  rootNode: _UILayer.default.propTypes.rootNode,
  scrollElementRef: _refObject.default.isRequired,
  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  _dontMakeNewLayer: _react.PropTypes.bool,
  panelKey: (0, _decorators.hidden)(_react.PropTypes.string),
  panelNavigatorContext: (0, _decorators.hidden)(_PanelNavigatorContext.panelNavigatorContextPropType)
};
UIPanel.contextTypes = {
  sandboxed: _react.PropTypes.bool
};
UIPanel.defaultProps = {
  align: 'right',
  animate: true,
  width: '30%',
  _dontMakeNewLayer: false
};
UIPanel.displayName = 'UIPanel';

var _default = (0, _ShareScrollElement.default)((0, _PanelNavigatorContext.ConsumesPanelNavigatorContext)(UIPanel));

exports.default = _default;
module.exports = exports.default;